import React from 'react';
import Loading from 'react-fullscreen-loading';
const Loader = () => {
        return (
            <div>
                <Loading loading loaderColor="#850666" />
            </div>
        );
}

export default Loader;